// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__1BQ3L","box":"WorkspacesBox_box__3LZ9r","node":"WorkspacesBox_node__1aXel"};